module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-2.88902023.png";